import { api } from '../api';
import type { Location } from '@/types/location';
import type { PaginatedResponse, PaginationParams } from '@/types/common';
import type { DashboardLocationsStats } from '@/types/company';

export const locationApi = {
  paginate: (params?: PaginationParams & { search?: string; companyId?: number; regionId?: number; isActive?: boolean }) => {
    const query = new URLSearchParams();
    if (params) {
      Object.entries(params).forEach(([k, v]) => {
        if (v !== undefined && v !== null) query.set(k, String(v));
      });
    }
    const qs = query.toString();
    return api.get<PaginatedResponse<Location>>(`/locations${qs ? `?${qs}` : ''}`);
  },
  getAll: async (): Promise<Location[]> => {
    const first = await api.get<PaginatedResponse<Location>>('/locations?limit=100&page=1');
    const items: Location[] = [...first.data];
    const totalPages = first.meta?.totalPages ?? 1;
    for (let page = 2; page <= totalPages; page++) {
      const next = await api.get<PaginatedResponse<Location>>(`/locations?limit=100&page=${page}`);
      items.push(...next.data);
    }
    return items;
  },
  getById: (id: string) => api.get<Location>(`/locations/${id}`),
  create: (data: Partial<Location>) => api.post<Location>('/locations', data),
  update: (id: string, data: Partial<Location>) => api.patch<Location>(`/locations/${id}`, data),
  delete: (id: string) => api.delete(`/locations/${id}`),
  getStats: () => api.get<DashboardLocationsStats>(`/locations/stats`),
  getScopedStats: (filters: { organizationId?: number; companyId?: number; regionId?: number }) => {
    const params = new URLSearchParams();
    if (filters?.organizationId !== undefined) params.set('organizationId', String(filters.organizationId));
    if (filters?.companyId !== undefined) params.set('companyId', String(filters.companyId));
    if (filters?.regionId !== undefined) params.set('regionId', String(filters.regionId));
    const query = params.toString();
    return api.get<DashboardLocationsStats>(`/locations/stats${query ? `?${query}` : ''}`);
  },
};
